import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { EMAILJS_CONFIG } from '../config/emailjs.config';

const AgentForm = () => {
  const [formData, setFormData] = useState({
    mobile: '',
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    setError('');

    // Template parameters matching your EmailJS template
    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.mobile,
      message: formData.message || 'No message provided',
    };

    emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATES.AGENT_FORM,
      templateParams,
      EMAILJS_CONFIG.PUBLIC_KEY
    )
      .then((response) => {
        console.log('Email sent successfully:', response);
        setSubmitted(true);
        setSending(false);
        setTimeout(() => {
          setSubmitted(false);
          setFormData({ mobile: '', name: '', email: '', message: '' });
        }, 3000);
      })
      .catch((error) => {
        console.error('Email send failed:', error);
        setError('Failed to send. Please try again or contact us directly.');
        setSending(false);
      });
  };

  return (
    <section id="agent-form" className="py-16 bg-gradient-to-br from-primary-900 to-primary-700">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="text-white">
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
                BECOME AN AUTHORIZED FASTAG AGENT TODAY!
              </h2>
              <p className="text-xl mb-8 text-primary-100">
                Start your business with India's leading banks — SBI & IDFC First Bank
              </p>

              <div className="space-y-4 mb-8">
                <h3 className="text-2xl font-semibold mb-4">What We Offer Agents:</h3>
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-secondary-400 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Instant SBI & IDFC Agent ID Activation</span>
                </div>
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-secondary-400 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Direct FASTag Stock Supply</span>
                </div>
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-secondary-400 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Maximum Commission Margin</span>
                </div>
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-secondary-400 mr-3 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>24/7 Backend Support for tag issues, portal errors, and KYC</span>
                </div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <h4 className="font-semibold mb-3 text-lg">Who Can Apply:</h4>
                <p className="text-primary-100">
                  Toll Plaza Agents, Cyber café owners, RTO agents, car accessories shops,
                  and independent entrepreneurs
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-2xl p-8">
              <h3 className="text-2xl font-bold text-neutral-900 mb-6">Agent Registration Form</h3>

              {submitted ? (
                <div className="bg-secondary-50 border border-secondary-200 rounded-lg p-6 text-center">
                  <svg className="w-16 h-16 text-secondary mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <h4 className="text-xl font-semibold text-secondary-800 mb-2">Thank You!</h4>
                  <p className="text-secondary-700">We will contact you shortly to complete your agent registration.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  {error && (
                    <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-center">
                      <p className="text-red-700">{error}</p>
                    </div>
                  )}
                  <div>
                    <label className="block text-neutral-700 font-semibold mb-2" htmlFor="agent-mobile">
                      Mobile Number *
                    </label>
                    <input
                      type="tel"
                      id="agent-mobile"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      pattern="[0-9]{10}"
                      placeholder="Enter 10-digit mobile number"
                      required
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                    />
                  </div>

                  <div>
                    <label className="block text-neutral-700 font-semibold mb-2" htmlFor="agent-name">
                      Full Name *
                    </label>
                    <input
                      type="text"
                      id="agent-name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your full name"
                      required
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                    />
                  </div>

                  <div>
                    <label className="block text-neutral-700 font-semibold mb-2" htmlFor="agent-email">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      id="agent-email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email address"
                      required
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                    />
                  </div>

                  <div>
                    <label className="block text-neutral-700 font-semibold mb-2" htmlFor="agent-message">
                      Message / Business Details
                    </label>
                    <textarea
                      id="agent-message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="4"
                      placeholder="Tell us about your business (optional)"
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    disabled={sending}
                    className="w-full bg-gradient-to-r from-primary-600 to-primary-800 text-white py-4 rounded-lg font-semibold hover:from-primary-700 hover:to-primary-900 transition shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {sending ? 'Sending...' : 'Submit Agent Application'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgentForm;
